import { useRef, useState } from 'react';

export const useReconPaths = (initialPaths, clearFieldError) => {
  const nextId = useRef(0);

  const createPath = (value = '') => ({ id: nextId.current++, value });

  const createPaths = (paths) => {
    if (paths.length > 0) {
      return paths.map(createPath);
    }
    return [createPath()];
  };

  const [reconPaths, setReconPaths] = useState(() => createPaths(initialPaths));

  const addReconPath = () => {
    setReconPaths((current) => [...current, createPath()]);
  };

  const updateReconPath = (index, value) => {
    setReconPaths((current) =>
      current.map((path, pathIndex) => {
        if (pathIndex === index) {
          return { ...path, value };
        }
        return path;
      }),
    );
    clearFieldError(`recon_paths[${index}]`);
    clearFieldError('recon_paths');
  };

  const removeReconPath = (id) => {
    setReconPaths((current) => current.filter((path) => path.id !== id));
    clearFieldError('recon_paths');
  };

  const setSavedReconPaths = (paths) => setReconPaths(createPaths(paths));

  const reconPathValues = () => reconPaths.map((path) => path.value);

  return {
    reconPaths,
    addReconPath,
    updateReconPath,
    removeReconPath,
    setSavedReconPaths,
    reconPathValues,
  };
};
